import type { GameCardData } from "./game-card";

export const polygonGames: GameCardData[] = [
  {
    id: "bushwhack",
    name: "Bushwhack",
    subtitle: "Earn 500 Gems.",
    description:
      "Complete quests as they launch for this top-tier Polygon games to earn a massive 500 Gems! More reward details coming soon...",
    icon: "/images/polygon-games/bushwhack-polygon-icon.webp",
    backgroundImage: "/images/polygon-games/bushwhack-polygon-card-bg.webp",
    url: "https://moonveil.gg/Bushwhack",
    slug: "bushwhack",
  },
  {
    id: "miomi-games",
    name: "500 Gems.",
    subtitle: "MIOMI Games — become a eSports star",
    description:
      "Complete quests as they launch for this top-tier Polygon games to earn a massive 500 Gems! More reward details coming soon...",
    icon: "/images/polygon-games/miomi-polygon-icon.webp",
    backgroundImage: "/images/polygon-games/miomi-polygon-card-bg.webp",
    url: "https://miomi.game/",
    slug: "miomi-game",
  },
  {
    id: "wild-worlds",
    name: "Wilder Worlds",
    subtitle: "Earn 500 Gems.",
    description:
      "Complete quests as they launch for this top-tier Polygon games to earn a massive 500 Gems! More reward details coming soon...",
    icon: "/images/polygon-games/wilder-worlds-polygon-icon.webp",
    backgroundImage: "/images/polygon-games/wilder-worlds-polygon-card-bg.webp",
    url: "https://www.wilderworld.com/",
    slug: "wilder-world",
  },
  {
    id: "voxies",
    name: "VOXIES",
    subtitle: "Earn 500 Gems.",
    description:
      "Complete quests as they launch for this top-tier Polygon games to earn a massive 500 Gems! More reward details coming soon...",
    icon: "/images/polygon-games/voxies-polygon-icon.webp",
    backgroundImage: "/images/polygon-games/voxies-polygon-card-bg.webp",
    url: "https://www.voxies.io/",
    slug: "voxies-tactics",
  },
  {
    id: "soccerverse",
    name: "Soccerverse",
    subtitle: "Earn 500 Gems.",
    description:
      "Complete quests as they launch for this top-tier Polygon games to earn a massive 500 Gems! More reward details coming soon...",
    icon: "/images/polygon-games/soccerverse-polygon-icon.webp",
    backgroundImage: "/images/polygon-games/soccerverse-polygon-card-bg.webp",
    url: "https://soccerverse.com/",
  },
];
